export default "__VITE_ASSET__3f9f1dfd__"